/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivationWithUpdateModel
 */
export interface ActivationWithUpdateModel {
    /**
     * 
     * @type {number}
     * @memberof ActivationWithUpdateModel
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ActivationWithUpdateModel
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ActivationWithUpdateModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ActivationWithUpdateModel
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ActivationWithUpdateModel
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof ActivationWithUpdateModel
     */
    companyName: string;
}

export function ActivationWithUpdateModelFromJSON(json: any): ActivationWithUpdateModel {
    return ActivationWithUpdateModelFromJSONTyped(json, false);
}

export function ActivationWithUpdateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivationWithUpdateModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'lastName': json['lastName'],
        'phone': json['phone'],
        'companyName': json['companyName'],
    };
}

export function ActivationWithUpdateModelToJSON(value?: ActivationWithUpdateModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'lastName': value.lastName,
        'phone': value.phone,
        'companyName': value.companyName,
    };
}

